import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { LoadingIndicator } from '../../../../../components/loading-indicator.component';
import { useAuthorize } from '../../../../../hooks/use-authorize';
import { UserPermissionName } from '../../../../../models/user-permission-name';

interface DeletePlanDialog {
    isParentLoading: boolean;
    isDeleteLoading: boolean;
    onDeletePlan: () => void;
    onClosed: () => void;
}
export const DeletePlanDialog = ({ isParentLoading, isDeleteLoading, onDeletePlan, onClosed }: DeletePlanDialog) => {
    const isReadOnlyPermission = useAuthorize([UserPermissionName?.READ_ONLY]);
    return (
        <Dialog className="modalpopup" title={'CONFIRM DELETE'} onClose={onClosed}>
            <div>
                <div style={{ padding: '25px 50px' }}>
                    <div>Are you sure that you want to remove this plan?</div>
                    <LoadingIndicator isLoading={isDeleteLoading} />
                </div>
            </div>
            <DialogActionsBar>
                <div className=" spaceBetween">
                    <button className="btn btn-sm btn-default btn-lightGrey" onClick={onClosed} autoFocus>
                        Cancel
                    </button>
                    <button
                        className="btn btn-sm btn-danger btn-delete"
                        type="button"
                        style={{
                            backgroundColor: isReadOnlyPermission ? '#D7DBDD' : '#FF8A8A',
                            color: isReadOnlyPermission ? 'black' : '#fff'
                        }}
                        onClick={onDeletePlan}
                        disabled={isParentLoading || isReadOnlyPermission}
                    >
                        Delete
                    </button>
                </div>
            </DialogActionsBar>
        </Dialog>
    );
}